import { Directive, ElementRef, Input, NgModule, OnChanges } from '@angular/core';

@Directive({
  selector: '[bindCssVariable]',
})
export class BindCssVariableDirective implements OnChanges {
  @Input() bindCssVariable: {
    [key: string]: string;
  };

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnChanges() {
    Object.keys(this.bindCssVariable).forEach((key) =>
      this.host.nativeElement.style.setProperty(`--${key}`, this.bindCssVariable[key])
    );
  }
}

@NgModule({
  declarations: [BindCssVariableDirective],
  exports: [BindCssVariableDirective],
})
export class BindCssVariableModule {}



// WEBPACK FOOTER //
// ./ts/app/directives/bind-css-variable.directive.ts